import { Injectable, InjectionToken, Inject } from '@angular/core';
import * as DefaultLocale from 'date-fns/locale/en';

// DatePipe Manager by Aaron Sterling
// injection token
export interface AgoPipeOptions {
    refreshRate?: number;
    prefix?: string;
    suffix?: string;
    includeSeconds?: boolean;
}
export interface DatePipeConfiguration {
    defaultDateFormat?: string;
    dateDistanceIncludesSeconds?: boolean;
    agoPipeOptions?: AgoPipeOptions;
}
export const /** @type {?} */ DATE_PIPE_CONFIGURATION_TOKEN = new InjectionToken<DatePipeConfiguration>('date pipe configuration');

// default constants

const /** @type {?} */ INITIAL_DEFAULT_DATE_FORMAT = 'MMMM Do, YYYY';
const /** @type {?} */ DEFAULT_DATE_DISTANCE_INCLUDES_SECONDS = false;
const /** @type {?} */ DEFAULT_AGO_PIPE_OPTIONS: AgoPipeOptions = {
    refreshRate: 15000,
    prefix: '',
    suffix: ' ago',
    includeSeconds: false
};
export class DatePipeManager {
private dateFormat: string;
private formatToRevertTo: string;
private includeSeconds = DEFAULT_DATE_DISTANCE_INCLUDES_SECONDS;
private agoPipeOptions = Object.assign({}, DEFAULT_AGO_PIPE_OPTIONS);
private optionsToRevertTo: AgoPipeOptions;
/**
 * @param {?} userProvidedConfig
 */
constructor( userProvidedConfig: DatePipeConfiguration) {
        // set default date string
        if (userProvidedConfig && userProvidedConfig.defaultDateFormat) {
            this.initializeDefaultDateFormat(userProvidedConfig.defaultDateFormat);
        } else {
            this.initializeDefaultDateFormat(INITIAL_DEFAULT_DATE_FORMAT);
        }
        // set default whether distance includes seconds
        if (userProvidedConfig && userProvidedConfig.dateDistanceIncludesSeconds
                               && userProvidedConfig.dateDistanceIncludesSeconds === true) {
            this.includeSeconds = userProvidedConfig.dateDistanceIncludesSeconds;
        } else if (userProvidedConfig && typeof userProvidedConfig.dateDistanceIncludesSeconds === 'boolean'
                                      && userProvidedConfig.dateDistanceIncludesSeconds === false) {
            this.includeSeconds = false;
        }
        // set ago pipe defaults
        if (userProvidedConfig && userProvidedConfig.agoPipeOptions) {
            this.agoPipeOptions = Object.assign({}, this.agoPipeOptions, userProvidedConfig.agoPipeOptions);
            this.optionsToRevertTo = Object.assign({}, this.agoPipeOptions);
        }
    }
/**
 * @param {?} defaultFormat
 * @return {?}
 */
private initializeDefaultDateFormat(defaultFormat: string) {
        this.setDefaultFormat(defaultFormat);
        this.formatToRevertTo = defaultFormat;
    }
/**
 * @param {?=} overrideFormat
 * @return {?}
 */
getDefaultFormat(overrideFormat?: string): string {
        if (overrideFormat) {
            return overrideFormat;
        } else {
            return this.dateFormat;
        }
    }
/**
 * @param {?} newFormat
 * @return {?}
 */
setDefaultFormat(newFormat: string) {
        this.dateFormat = newFormat;
    }
/**
 * @return {?}
 */
resetDefaultFormat() {
        this.dateFormat = this.formatToRevertTo;
    }
/**
 * @return {?}
 */
includeSecondsInDistance() {
        this.includeSeconds = true;
    }
/**
 * @return {?}
 */
doNotIncludeSecondsInDistance() {
        this.includeSeconds = false;
    }
/**
 * @return {?}
 */
secondsIncludedInDistance(): boolean {
        return this.includeSeconds;
    }
/**
 * @param {?} options
 * @return {?}
 */
setAgoPipeOptions(options: AgoPipeOptions) {
        this.agoPipeOptions = Object.assign({}, this.agoPipeOptions, options);
    }
/**
 * @return {?}
 */
getAgoPipeOptions(): AgoPipeOptions {
        return this.agoPipeOptions;
    }
/**
 * @return {?}
 */
resetAgoPipeOptions() {
        this.agoPipeOptions = Object.assign({}, this.optionsToRevertTo);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [DATE_PIPE_CONFIGURATION_TOKEN, ] }, ]},
];
}

function DatePipeManager_tsickle_Closure_declarations() {
/** @type {?} */
DatePipeManager.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatePipeManager.ctorParameters;
/** @type {?} */
DatePipeManager.prototype.dateFormat;
/** @type {?} */
DatePipeManager.prototype.formatToRevertTo;
/** @type {?} */
DatePipeManager.prototype.includeSeconds;
/** @type {?} */
DatePipeManager.prototype.agoPipeOptions;
/** @type {?} */
DatePipeManager.prototype.optionsToRevertTo;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
